/** Root DOM element name to mount application's layout */
export const DOM_ROOT_CONTAINER_ID = 'root';

/** Modal root DOM element name to mount modals portal */
export const DOM_MODAL_ROOT_CONTAINER_ID = 'modal_root';
